import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "size"];
import React from 'react';
import Option from './Option';
import Group from './Group';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
var InternalSelect = (props, ref) => {
  var {
      prefixCls = 'w-select',
      className,
      size = 'default'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("select", _extends({}, other, {
    ref: ref,
    className: [prefixCls, className, size ? prefixCls + "-" + size : null].filter(Boolean).join(' ').trim()
  }));
};
var Select = /*#__PURE__*/React.forwardRef(InternalSelect);
Select.Option = Option;
Select.Group = Group;
export default Select;